import * as React from "react";
import styles from "./NavigationBar.module.scss";
import { useNavigate } from "react-router-dom";

const navigationLinks = [
  { id: 1, text: "About Us", link: "/about-us" },
  { id: 2, text: "Contact", link: "/support" }
];

function NavigationBar() {
  const navigate = useNavigate();

  return (
    <nav className={styles.navigationBar}>
      <div className={styles.brandSection}>
        <div className={styles.brandLogo} onClick={() => navigate("/")}>
          TROAK
        </div>
        <div className={styles.navigationLinks}>
          {navigationLinks.map((link) => (
            <div
              className={styles.navLink}
              onClick={() => {
                navigate(link.link);
              }}
            >
              {link.text}
            </div>
          ))}
        </div>
      </div>
      <div className={styles.actionSection}>
        <div className={styles.buttonWrapper}>
          <a href="https://apps.apple.com/in/app/troak-interactive-stories/id6739448231" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
            <button className={styles.buttonContent} tabIndex="0">
              <span className={styles.buttonText}>Download</span>
            </button>
          </a>
        </div>
      </div>
    </nav>
  );
}

export default NavigationBar;
